import { PdpTagTextBox } from "@/app/ec/product/[basePath]/manufacturer-promotions/productDetailPagePromotionTagBox";

export const formatTagText = (tagText: string): PdpTagTextBox => {
  const matches = tagText.match(/\[(.*?)\]/);
  const beforeText = tagText.substring(0, tagText.indexOf("["));
  const afterText = tagText.split("]").pop();
  return {
    openText: matches ? matches[1] : "",
    beforeText,
    afterText: afterText ?? "",
  };
};
